// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { LMkeywords, ListingKeywordsData } from './types';

export interface ActionGetLMKeywordsAPI extends Action {
  listingId: string
}

export const getLMKeywordsAPI = (listingId: string): ActionGetLMKeywordsAPI => ({
  type: ACTIONS.GET_LMKEYWORDS_API_REQUEST,
  listingId,
});

export interface ActionGetLMKeywordsAPISuccess extends Action {
  lmkeywords: LMkeywords
}

export const getLMKeywordsAPISuccess = (lmkeywords: LMkeywords): ActionGetLMKeywordsAPISuccess => ({
  type: ACTIONS.GET_LMKEYWORDS_API_SUCCESS,
  lmkeywords
});

export const getLMKeywordsAPIError = (): Action => ({
  type: ACTIONS.GET_LMKEYWORDS_API_ERROR,
});


export interface ActionPostLMKeywordsAPI extends Action {
  listingId: string;
  keywordsData: ListingKeywordsData;
}

export const postLMKeywordsAPI = (listingId: string, keywordsData: ListingKeywordsData): ActionPostLMKeywordsAPI => ({
  type: ACTIONS.POST_LMKEYWORDS_API_REQUEST,
  listingId,
  keywordsData,
});

export interface ActionPostLMKeywordsAPISuccess extends Action {
  lmkeywords: LMkeywords
}

export const postLMKeywordsAPISuccess = (lmkeywords: LMkeywords): ActionPostLMKeywordsAPISuccess => ({
  type: ACTIONS.POST_LMKEYWORDS_API_SUCCESS,
  lmkeywords
});

export const postLMKeywordsAPIError = (): Action => ({
  type: ACTIONS.POST_LMKEYWORDS_API_ERROR,
});